export function updateSelection<T extends { id: string }>(selected: T[], items: T[], checked: boolean): T[] {
  const next = new Map(selected.map((item) => [item.id, item]));
  for (const item of items) {
    if (checked) next.set(item.id, item);
    else next.delete(item.id);
  }
  return [...next.values()];
}
